module.exports = __webpack_public_path__ + "static/media/banner_oquefalam_02-small.997f5a9b.png";